import { tokens } from "shared/components/Spor";

import { Grey, WhiteAlpha } from "shared/theme/sidespor/types";
import { appPalette } from "shared/theme/sidespor/theme/appPalette";

const { palette, alias } = tokens.default.color;

const colors: Record<string, string | WhiteAlpha | Grey> = {
  ...appPalette,
  ...alias,
  ...palette,
};

export default colors;
